import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';

import DispatchSummary from './DispatchSummary';
import LoadingComponent from './LoadingComponent';

import HighlightedCard from './HighlightedCard';
import PageViewsBarChart from './PageViewsBarChart';
import SessionsChart from './SessionsChart';
import StatCard from './StatCard';
import AppCurrentSubject from './AppCurrentSubject';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectSummationsiteData, selectSummationsiteStatus, fetchSummationsiteDataWithFilters
} from '../../features/summationsite/summationsiteSlice';

import {
  selectEvstatusData, fetchEvstatusDataWithFilters
} from '../../features/evstatus/evstatusSlice';

import {
  selectSmartmeterData, selectSmartmeterStatus, fetchSmartmeterDataWithFilters
} from '../../features/smartmeter/smartmeterSlice';

import {
  selectSumchargeData, selectSumchargeStatus, fetchSumchargeDataWithFilters
} from '../../features/sumcharge/sumchargeSlice';

import {
  selectPriceData, selectPriceStatus, fetchPriceDataWithFilters
} from '../../features/price/priceSlice';

import {
  selectBatterystatusData, fetchBatterystatusDataWithFilters
} from '../../features/batterystatus/batterystatusSlice';

import {
  selectVehicledetailsData, fetchVehicledetailsDataWithFilters
} from '../../features/vehicledetails/vehicledetailsSlice';

// import {
//   selectCurrentstatusData,
//   selectCurrentstatusStatus,
//   fetchCurrentstatusDataWithFilters
// } from '../../features/currentstatus/currentstatusSlice';

import {
  selectActivecarinfoData,
  selectActivecarinfoStatus,
  fetchActivecarinfoDataWithFilters
} from '../../features/activecarinfo/activecarinfoSlice';


import {
  selectVehicleData, selectVehicleStatus, fetchVehicleDataWithFilters
} from '../../features/vehicle/vehicleSlice';

import {
  selectOptimizationData,
  selectOptimizationStatus, fetchOptimizationDataWithFilters
} from '../../features/optimization/optimizationSlice';
import {
  selectPredictionData,
  selectPredictionStatus,
  fetchPredictionDataWithFilters
} from '../../features/prediction/predictionSlice';
import {
  selectBuildingforecastStatus,
  fetchBuildingforecastDataWithFilters,
  selectBuildingforecastData
} from '../../features/buildingforecast/buildingforecastSlice';

import {
  selectNetloadStatus,
  fetchNetloadDataWithFilters,
  selectNetloadData
} from '../../features/netload/netloadSlice';
import {
  selectQueryDate
} from '../../features/uidata/uidataSlice';
import PagedCarsVehicle from './PagedCarsVehicle'
import {
  getMinTime,
  getMaxTime,
  cloneDatetTime
} from '../utils/datetimeUtils';
import { roundToNearestFiveMinutes, roundToTwoDigits, timeArrays } from '../utils/dbUtils';
function sumValuesByTime(data, interval = "hour") {
  return Object.values(
    data.reduce((acc, { date, value }) => {
      const d = new Date(date);
      let groupDate;

      if (interval === "date") {
        groupDate = roundToNearestFiveMinutes(new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
      } else if (false && interval === "hour") {
        groupDate = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours());
      } else if (interval === "hour" || interval === "10min") {
        const minutes = Math.floor(d.getUTCMinutes() / 10) * 10;
        groupDate = roundToNearestFiveMinutes(new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), minutes));
      } else {
        throw new Error("Invalid interval. Use 'date', 'hour', or '10min'.");
      }
      const key = groupDate.getTime(); // Using timestamp as key for uniqueness
      if (!acc[key]) {
        acc[key] = { date: groupDate, value: 0 };
      }
      acc[key].value += value;
      return acc;
    }, {})
  );
}
function smartmeterGroupByTime({ smartMeter, startDate, endDate }) {
  const data = [];
  for (let i = 0; i < smartMeter.length; i++) {
    const d = roundToNearestFiveMinutes(new Date((smartMeter[i].time_count) * 1000));
    if (smartMeter[i]['Converted delta Energy Sum Element']) {
      if (smartMeter[i]['Converted delta Energy Sum Element'] && d.getTime() >= startDate.getTime() && d.getTime() <= endDate.getTime()) {
        data.push({
          date: d,
          value: smartMeter[i]['Converted delta Energy Sum Element']
        });
      }
    }
  }
  const result = {
    smartmeter: {}
  };
  result.smartmeter.data = data;
  result.smartmeter.ByDay = sumValuesByTime(data, 'date');
  return result.smartmeter;
}
function chargeGroupByTime({ sumCharge, startDate, endDate }) {
  const { time_range, sum_charge, sum_discharge } = sumCharge;
  if (!!time_range === false) {
    return { charges: [] }
  }
  const charges = [];
  const discharges = [];
  for (let i = 0; i < time_range.length; i++) {
    const date = roundToNearestFiveMinutes(new Date(time_range[i]));
    if (date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime()) {
      charges.push({
        date,
        value: roundToTwoDigits(sum_charge[i])
      });
      discharges.push({
        date,
        value: roundToTwoDigits(sum_discharge[i])
      });
    }
  }
  const result = { charges: {}, discharges: {} };
  result.charges.data = charges; //sumValuesByTime(charges, 'hour');
  result.charges.ByDay = sumValuesByTime(charges, 'date');
  result.discharges.data = discharges; // sumValuesByTime(discharges, 'hour');
  result.discharges.ByDay = sumValuesByTime(discharges, 'date');
  return result;
}



function getDayDifference(date1, date2) {
  // Convert both dates to milliseconds
  const time1 = new Date(date1).getTime();
  const time2 = new Date(date2).getTime();
  // Calculate the difference in milliseconds
  const diffInMilliseconds = Math.abs(time1 - time2);
  // Convert milliseconds to days
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
  return Math.floor(diffInDays);
}
function sumArray(data) {
  return data.reduce((sum, item) => sum + item.value, 0);
}


function buildChargeGraphData(dataArr, startDate, endDate) {
  if (!!dataArr === false || Array.isArray(dataArr) === false || !dataArr.length) {
    return [];
  }

  const sumCharge = dataArr?.[0];
  const lastDays = getDayDifference(startDate, endDate);
  const chargeResult = chargeGroupByTime({ sumCharge, startDate, endDate });
  const dischargeTotal = sumArray(chargeResult.discharges.ByDay);
  const chargesTotal = sumArray(chargeResult.charges.ByDay);
  return {
    chargeResult,
    chargesTotal,
    dischargeTotal,
    stacks: [
      {
        title: 'Vehicles Charges',
        value: `${chargesTotal.toFixed(2)} kWh`,
        interval: `Last ${lastDays} days`,
        trend: 'up',
        data: chargeResult.charges.data,
      },
      {
        title: 'Vehicle DisCharges',
        value: `${dischargeTotal.toFixed(2)} kWh`,
        interval: `Last ${lastDays} days`,
        trend: 'down',
        data: chargeResult.discharges.data,
      },
      {
        title: 'Vehicle DisCharges',
        value: `${dischargeTotal.toFixed(2)} kWh`,
        interval: `Last ${lastDays} days`,
        trend: 'down',
        data: chargeResult.discharges.data,
      },
      // {
      //   title: 'Vehicle count',
      //   value: 0,
      //   interval: `Last ${lastDays} days`,
      //   trend: 'neutral',
      //   data: vehicleCount,
      // },
    ]
  }
}

function buildSmartmeterGraphData(dataArr, startDate) {
  if (!!dataArr === false) {
    return null;
  }
  const smartmeterUsage = smartmeterGroupByTime({
    smartMeter: dataArr,
    startDate,
    endDate: new Date()
  });
  return smartmeterUsage;

}
function generateMongoFilter(field, startDate, endDate) {
  return {
    [field]: {
      $gte: startDate,
      $lte: endDate
    }
  };
}

export default function MainGrid() {

  const dispatch = useDispatch();
  const netloadAPIData = useSelector(selectNetloadData);
  const netloadStatus = useSelector(selectNetloadStatus);

  const summationsiteAPIData = useSelector(selectSummationsiteData);
  const summationsiteStatus = useSelector(selectSummationsiteStatus);

  const smartmeterAPIData = useSelector(selectSmartmeterData);
  const buildingforecastData = useSelector(selectBuildingforecastData);
  const vehicleAPIData = useSelector(selectVehicleData);
  const predictionAPIData = useSelector(selectPredictionData);
  const optimizationAPIData = useSelector(selectOptimizationData);
  // const currentstatusAPIData = useSelector(selectCurrentstatusData);
  const activecarInfoAPIData = useSelector(selectActivecarinfoData);
  const evstatusAPIData = useSelector(selectEvstatusData);
  const priceAPIData = useSelector(selectPriceData);
  const sumchargeAPIData = useSelector(selectSumchargeData);
  //
  const smartmeterStatus = useSelector(selectSmartmeterStatus);
  const vehicleStatus = useSelector(selectVehicleStatus);
  const predictionStatus = useSelector(selectPredictionStatus);
  // const currentstatusStatus = useSelector(selectCurrentstatusStatus);
  const activecarinfoStatus = useSelector(selectActivecarinfoStatus);
  const sumchargeStatus = useSelector(selectSumchargeStatus);
  const priceStatus = useSelector(selectPriceStatus);
  const buildingforecastStatus = useSelector(selectBuildingforecastStatus);
  const optimizationStatus = useSelector(selectOptimizationStatus);
  //
  const batterystatusAPIData = useSelector(selectBatterystatusData);

  const vehicledetailsAPIData = useSelector(selectVehicledetailsData);


  const { beginingDate: tempBeginingDate, endDate: tempEndDate } = useSelector(selectQueryDate);
  const beginingDate = new Date(tempBeginingDate);
  const endDate = new Date(tempEndDate);
  const lastDays = getDayDifference(beginingDate, endDate);
  const [vehicleState, setVehicleState] = useState(null);



  useEffect(() => {
    if (activecarinfoStatus === 'succeeded' &&
      predictionStatus === 'succeeded' && optimizationStatus === 'succeeded'
      && vehicleStatus === 'succeeded' && Array.isArray(vehicleAPIData?.results)) {
      const result = [];
      const set = new Set();

      const connectedVins = activecarInfoAPIData?.[0]?.connected_vehicles || [];
      for (const connectedVin of connectedVins) {
        // const vehicleInfo = vehicleAPIData.results.find(d => d.VIN === connectedVin) || {};
        const temp = { VIN: connectedVin.vin, };
        // 1N4AZ1BV8NC563690        
        if (!set.has(temp.VIN)) {
          set.add(temp.VIN);
          dispatch(fetchEvstatusDataWithFilters({ filter: { vin: temp.VIN } }));
          dispatch(fetchBatterystatusDataWithFilters({ filter: { vin: temp.VIN } }));
          dispatch(fetchVehicledetailsDataWithFilters({ filter: { vin: temp.VIN } }));

          temp.prediction = predictionAPIData.results.find(d => d.vin === temp.VIN) || [];
          temp.optimization = optimizationAPIData.results.find(d => d.vin === temp.VIN) || [];
          if (temp.prediction || temp.optimization) {
            result.push(temp);
          }
        }
      }
      setVehicleState(result);
    }
  }, [predictionStatus, optimizationStatus, vehicleStatus]);

  const apiAvailable = (status) => ['idle', 'succeeded'].includes(status);

  useEffect(() => {
    console.log('fetchapis');
    if (apiAvailable(activecarinfoStatus)) {
      dispatch(fetchActivecarinfoDataWithFilters({}));
    }
    if (apiAvailable(priceStatus)) {
      const filter = {
        start_time: {
          $lte: beginingDate.getTime()
        },
        end_time: {
          $gte: endDate.getTime()
        },
      };
      dispatch(fetchPriceDataWithFilters({ filter }));
    }
    if (apiAvailable(sumchargeStatus)) {
      // created_at      
      dispatch(fetchSumchargeDataWithFilters({}));
    }
    if (apiAvailable(predictionStatus)) {
      const filter = generateMongoFilter('arrival_time', beginingDate, endDate);
      dispatch(fetchPredictionDataWithFilters({ filter }));
    }
    if (apiAvailable(buildingforecastStatus)) {
      const filter = {
        // start_time: {
        //   $lte: beginingDate,
        // },
        end_time: {
          $gte: endDate.getTime()
        },
      };
      dispatch(fetchBuildingforecastDataWithFilters({ filter }));
    }
    if (apiAvailable(optimizationStatus)) {
      const filter = generateMongoFilter('arrival_time', beginingDate, endDate);
      dispatch(fetchOptimizationDataWithFilters({ filter }));
    }
    if (apiAvailable(netloadStatus)) {
      const filter = {
        end_time: {
          $gte: endDate.getTime()
        },
      };
      dispatch(fetchNetloadDataWithFilters({ filter }));
    }
    if (apiAvailable(vehicleStatus)) {
      const filterEndTime = getMinTime(endDate, new Date());
      const filter = generateMongoFilter('time', beginingDate, filterEndTime);
      dispatch(fetchVehicleDataWithFilters({ filter }));
    }
    if (apiAvailable(summationsiteStatus)) {
      const filterEndTime = getMinTime(endDate, new Date());
      const filter = generateMongoFilter('timestamp', beginingDate, filterEndTime);
      dispatch(fetchSummationsiteDataWithFilters({ filter }));
    }
    if (apiAvailable(smartmeterStatus)) {
      const filterEndTime = getMinTime(endDate, new Date());
      const filter = {
        time_count: {
          $gte: parseInt(beginingDate.getTime() / 1000), //  - (8 * 60),
          $lte: parseInt(filterEndTime / 1000) //  - (8 * 60)
        }
      };
      dispatch(fetchSmartmeterDataWithFilters({ filter }));
    }
  }, [tempBeginingDate, tempEndDate]);

  const apiFetchSuccess = (status) => ['succeeded'].includes(status)

  const sumchargeData = useMemo(() => {
    if (sumchargeAPIData?.results && apiFetchSuccess(sumchargeStatus)) {
      const filterEndTime = getMaxTime(endDate);
      return buildChargeGraphData(sumchargeAPIData.results, beginingDate, filterEndTime);
    }
    return [];
  }, [sumchargeStatus]);

  const smartmeterData = useMemo(() => {
    if (smartmeterAPIData?.results && apiFetchSuccess(smartmeterStatus)) {
      const filterEndTime = getMinTime(endDate);
      return buildSmartmeterGraphData(smartmeterAPIData?.results?.filter(d => !!d.time), beginingDate, filterEndTime);
    }
    return {}
  }, [smartmeterStatus]);



  const appAvailable = apiFetchSuccess(activecarinfoStatus) &&
    apiFetchSuccess(priceStatus) &&
    apiFetchSuccess(sumchargeStatus) &&
    apiFetchSuccess(predictionStatus) &&

    apiFetchSuccess(buildingforecastStatus) &&
    apiFetchSuccess(optimizationStatus) &&
    apiFetchSuccess(netloadStatus) &&

    apiFetchSuccess(vehicleStatus) &&
    apiFetchSuccess(summationsiteStatus) &&
    apiFetchSuccess(smartmeterStatus);
  if (!appAvailable) {
    return <LoadingComponent />
  }

  const charges = summationsiteAPIData?.results?.map(d => ({ date: roundToNearestFiveMinutes(new Date(d.timestamp)), value: roundToTwoDigits(d.charge_total) })).filter(d => d.value < 1000);
  const discharges = summationsiteAPIData?.results?.map(d => ({ date: roundToNearestFiveMinutes(new Date(d.timestamp)), value: roundToTwoDigits(d.discharge_total) })).filter(d => d.value < 1000);
  const disChargeMin = Math.min(...discharges.map(d => d.value));
  const { time_range = [], net_load = [] } = netloadAPIData.results?.[0] || {};
  let now = new Date();
  let showAnnotation = true;
  if (beginingDate.getTime() > now.getTime()) {
    now = cloneDatetTime(beginingDate);
    showAnnotation = false;
  }
  if (endDate.getTime() < now.getTime()) {
    now = cloneDatetTime(endDate);
    showAnnotation = false;
  }

  const netLoad = timeArrays({
    name: 'netload',
    timeRange: time_range, valueArray: net_load,
    filter: (d) => d.date.getTime() >= now.getTime() && d.date.getTime() <= endDate.getTime(),
    startDate: now,
    endDate: endDate,
  });
  const summerChart = timeArrays({
    name: 'summerChart',
    timeRange: priceAPIData?.results?.[0]?.time_series,
    valueArray: priceAPIData?.results?.[0]?.summer_price_signal,
    startDate: beginingDate,
    endDate: endDate,
    filter: (d) => d.date.getTime() >= beginingDate.getTime() && d.date.getTime() <= endDate.getTime()
  });

  const buildingforecast = timeArrays({
    name: 'buildingforecast',
    timeRange: buildingforecastData?.results?.[0]?.Time,
    valueArray: buildingforecastData?.results?.[0]?.predicted_load,
    startDate: now,
    endDate: endDate,
    filter: (d) => d.date.getTime() >= now.getTime() && d.date.getTime() <= endDate.getTime()
  });


  const scheduledCharging = timeArrays({
    name: 'scheduledcharge',
    timeRange: sumchargeAPIData?.results?.[0]?.time_range,
    valueArray: sumchargeAPIData?.results?.[0]?.sum_charge,
    startDate: now,
    endDate: endDate,
  });

  const scheduledDischarging = timeArrays({
    name: 'scheduledDischarging',
    timeRange: sumchargeAPIData?.results?.[0]?.time_range,
    valueArray: sumchargeAPIData?.results?.[0]?.sum_discharge,
    startDate: now,
    endDate: endDate,
  });

  // sumchargeAPIData.results



  // const netLoadFiltered = netLoad.filter(d => d.date.getTime() >= now.getTime() && d.date.getTime() <= endDate.getTime());
  // const summerChartTemp = summerChart.filter(d => d.date.getTime() >= beginingDate.getTime() && d.date.getTime() <= endDate.getTime());  
  // const buildingforecastFiltered = buildingforecast.filter(d => d.date.getTime() >= now.getTime() && d.date.getTime() <= endDate.getTime());



  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography> */}
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(1) }}
      >
        <Grid size={{ xs: 12, sm: 12, lg: 12 }}>
          <PagedCarsVehicle carData={vehicleState} evstatus={evstatusAPIData} piedata = {batterystatusAPIData} detailsdata = {vehicledetailsAPIData} />
        </Grid>
      </Grid>
      

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}

